export default __webpack_public_path__ + "static/media/V40.275a71fe.png";